module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "explore"
  }, [_c('h2', {
    staticClass: "h-l explore-title"
  }, [_vm._v("explore")]), _c('div', {
    staticClass: "exploreContainer"
  }, [_c('swiper', {
    ref: "gallery",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.explore), function(item) {
    return _c('swiper-slide', {
      key: item.text
    }, [_c('a', {
      attrs: {
        "href": item.link
      }
    }, [_c('div', {
      staticClass: "slide"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": item.image_url,
        "alt": item.text
      }
    }), _c('div', {
      staticClass: "gradient"
    })]), _c('h2', {
      staticClass: "h-ml"
    }, [_vm._v(_vm._s(item.text))])])])
  }), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cd54169"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/HomeExplore.vue
// module id = 229
// module chunks = 1